import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const getFundReviewFlag = async () => {
  const url = '/feature-flag/fund-review-visibility';
  return request.get(url);
};
